import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomHttp } from '../../../common/customHttp.service';
import { ApiUrl } from '../../../common/apiUrls';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ValidationService } from '../../../common/validationservice';
import { MainAppComponent } from '../../../layout/layout.component';
import 'rxjs/add/operator/map';
import { JobCardDDLModel, GraphTempTypeDDLModel } from '../../../common/viewModels/Analysis/SampleModel';
import { LabModel } from '../../../common/viewModels/Admin/LabModel';
import { CustomerModel } from '../../../common/viewModels/Admin/CustomerModel';

declare var $: any;

@Component({
    selector: 'importsample',
    templateUrl: './importsample.component.html',
    styleUrls: ['./importsample.component.scss']
})

export class ImportSampleComponent implements OnInit {
    ImportSampleForm: FormGroup;
    lstJobCards: JobCardDDLModel[];
    lstJobCardsTemp: JobCardDDLModel[];
    lstGraphTypes: GraphTempTypeDDLModel[];
    lstReportTypes: any[];
    lstSampleTypes: any[];
    labs: LabModel[];
    customers: CustomerModel[];
    excelFile: FormData = new FormData();
    isSubmitted: boolean = false;
    numbers = '^[0-9]+$';

    constructor(public _router: Router, private _formBuilder: FormBuilder,
        private _http: CustomHttp,
        private _appUrl: ApiUrl, private _route: ActivatedRoute, private _validationService: ValidationService,
        private _mApp: MainAppComponent, private _toastrService: ToastrService
    ) {

    }


    ngOnInit() {
        this.CreateForm();
        this.GetJobCradsForDDL();
        this.GetGraphTemplateTypesForDDL();
        this.GetReportTemplatesMinInfoList();
        this.GetSampleTypes();
        this.GetLabs();
        this.GetCustomers();
    }

    CreateForm() {
        this.ImportSampleForm = this._formBuilder.group({
            JobCardNumber: ['', Validators.compose([Validators.required, this._validationService.ValidateDropdownList,])],
            SampleTypeId: ['', Validators.compose([Validators.required, this._validationService.ValidateDropdownList])],
            ReportTemplateTypeId: ['', Validators.compose([Validators.required, this._validationService.ValidateDropdownList])],
            GraphTemplateTypeId: ['', Validators.compose([Validators.required, this._validationService.ValidateDropdownList])],
            ImportedFileName: [''],
            CustomerId: ['', Validators.compose([Validators.required, this._validationService.ValidateDropdownList])],
            LabId: ['', Validators.compose([Validators.required, this._validationService.ValidateDropdownList])],
            BottlesReceived: ['', Validators.compose([Validators.required, Validators.min(1), Validators.max(250), Validators.pattern(this.numbers)])],
        })
    }

    GetJobCradsForDDL() {
        this._mApp.ShowLoader();
        this._http.get(this._appUrl.GetJobcradsForDDL)
            .subscribe(
                data => {

                    this._mApp.HideLoader();
                    this.lstJobCards = data.json().Result;
                    this.lstJobCardsTemp = data.json().Result;
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '');
                }
            );
    }

    GetGraphTemplateTypesForDDL() {
        this._mApp.ShowLoader();
        this._http.get(this._appUrl.GetGraphTempleteTypeList)
            .subscribe(
                data => {
                    this._mApp.HideLoader();
                    this.lstGraphTypes = data.json().Result;
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '');
                }
            );
    }

    GetReportTemplatesMinInfoList() {
        this._http.get(this._appUrl.GetReportTemplatesMinInfoList)
            .subscribe(
                data => {
                    if (data.json().Result != null)
                        this.lstReportTypes = data.json().Result;
                },
                error => {
                    this._toastrService.error(error.json().Result);
                }
            )
    }

    GetSampleTypes() {
        this._http.get(this._appUrl.GetMinInfoSampleTypes)
            .subscribe(
                data => {
                    if (data.json().Result != null)
                        this.lstSampleTypes = data.json().Result;
                },
                error => {
                    this._toastrService.error(error.json().Result);
                }
            )
    }


    GetLabs() {
        this._http.get(this._appUrl.GetLabsMinInfoList)
            .subscribe(
                data => {
                    let lstLabs = data.json().Result;
                    if (this._mApp.currentUserLabIds && lstLabs)
                        lstLabs = lstLabs.filter(m => this._mApp.currentUserLabIds.includes(m.LabId));
                    this.labs = lstLabs;
                },
                error => {
                    this._toastrService.error(error.json().Result)
                }
            )
    }

    GetCustomers() {
        this._http.get(this._appUrl.GetCustomersMinInfoList)
            .subscribe(
                data => {
                    if (data.json().Result != null)
                        this.customers = data.json().Result;
                },
                error => {
                    this._toastrService.error(error.json().Result)
                }
            )
    }

    UploadExcelReport(event: any) {
        this.excelFile = new FormData();
        //this.ferroFiles = [];
        var element = ((window.event) ? (event.srcElement) : (event.currentTarget));
        var srcElement = event.srcElement || event.target;
        var files = srcElement.files;
        var size = files[0].size;
        let formData = new FormData();

        for (let i = 0; i < files.length; i++) {
            var ext = files[i].name.split('.').reverse()[0].toLowerCase();
            if (ext == "xlsx" || ext == "xls") {
                this.excelFile = new FormData();
                this.excelFile.append("uploads[]", files[i], files[i].name);
                var fileName = files[i].name.split('.').slice(0, -1).join('.');
                this.SaveImportedSampleReport();

            }
            else {
                this._toastrService.error("Please upload .xlsx or .xls files only");
                $("#fileUpload").val('');
                break;
            }
        }
    }

    SaveImportedSampleReport() {
        this._mApp.ShowLoader();
        this._http.postUpload(this._appUrl.SaveImportedSampleReport, this.excelFile)
            .subscribe(
                data => {
                    this._mApp.HideLoader();
                    var res = data.json().Result;
                    if (res != null && res != '') {
                        this.ImportSampleForm.controls['ImportedFileName'].setValue(res);
                    }
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result);
                    this.ImportSampleForm.controls['ImportedFileName'].setValue(null);

                }
            )
    }

    onSubmit() {
        this.isSubmitted = true;
        let SampleReport = this.ImportSampleForm.value;
        if (SampleReport.JobCardNumber != null && SampleReport.JobCardNumber != '' && SampleReport.JobCardNumber != undefined)
            SampleReport.JobCardId = SampleReport.JobCardNumber.JobCardId;
        if (SampleReport.JobCardId > 0)
            SampleReport.JobCardNumber = null;

        if (this.ImportSampleForm.valid) {
            let sampleReport = this.ImportSampleForm.value;
            if (sampleReport.ImportedFileName != null && sampleReport.ImportedFileName != '' && sampleReport.ImportedFileName != undefined) {
                this._mApp.ShowLoader();
                this._http.post(this._appUrl.ImportSampleReport, sampleReport)
                    .subscribe(
                        data => {
                            this._mApp.HideLoader();
                            this._toastrService.success(data.json().Result);
                            this._router.navigate(['/samplestatus']);
                        },
                        error => {
                            this._mApp.HideLoader();
                            let errorResult = error.json();
                            if (errorResult.StatusCode = 417)
                                this._toastrService.warning(errorResult.Result);
                            else
                                this._toastrService.error(errorResult.Result);
                        }
                    )
            }
            else {
                this._toastrService.error('Please upload excel file');
            }
        }
    }

    filterJobCard(val) {

        this.lstJobCards = this.lstJobCardsTemp.filter(m => m.JobCardNumber.toLowerCase().indexOf(val.toLowerCase()) === 0);
    }

    displayJobCard(jobCard) {
        return jobCard ? jobCard.JobCardNumber : jobCard;
    }

    PopulateCustomerAndLabByJobCard(event, jobCard) {
        if (event.source.selected) {
            let jobCardId = jobCard.JobCardId
            this._http.get(this._appUrl.GetJobCardByJobCardId + jobCardId)
                .subscribe(
                    data => {
                        let res = data.json().Result;
                        this._mApp.HideLoader();
                        if (res != null && res != '') {
                            this.ImportSampleForm.controls['CustomerId'].setValue(res.CustomerId);
                            this.ImportSampleForm.controls['LabId'].setValue(res.LabId);
                        }
                    },
                    error => {
                        this._mApp.HideLoader();
                        this._toastrService.error(error.json().Result);
                    }
                )
        }
    }
}